"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchItunes = void 0;
/**
 * Fetches podcast data from iTunes using the provided iTunes ID or search term.
 * Optionally, matches the result with a provided feed URL.
 *
 * @param source - The iTunes ID (number) or search term (string) of the podcast.
 * @param feedUrl - Optional feed URL to match with the search results.
 * @returns A promise that resolves to the podcast data or undefined if no matching result is found.
 */
function fetchItunes(source, feedUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = typeof source === "number"
            ? `https://itunes.apple.com/lookup?id=${source}&entity=podcast`
            : `https://itunes.apple.com/search?term=${encodeURIComponent(source)}&entity=podcast`;
        const response = yield fetch(url);
        if (!response.ok) {
            return undefined;
        }
        const data = (yield response.json());
        const matchingResult = data.results.find((result) => {
            const matchesId = typeof source === "number" ? result.collectionId === source : false;
            const matchesFeedUrl = feedUrl
                ? result.feedUrl &&
                    result.feedUrl.replace(/^https?:\/\//, "").replace(/\/$/, "") ===
                        feedUrl.replace(/^https?:\/\//, "").replace(/\/$/, "")
                : false;
            return matchesId || matchesFeedUrl;
        });
        return matchingResult;
    });
}
exports.fetchItunes = fetchItunes;
